import { FaDiscord, FaGithub, FaMedium, FaTwitter } from 'react-icons/fa';

const SOCIALS = {
  // discord: { icon: <FaDiscord />, link: 'https://discord.gg/byq6uNTugq' },
  // github: { icon: <FaGithub />, link: 'https://github.com/cardinal-labs' },
  // medium: { icon: <FaMedium />, link: 'https://cardinal-labs.medium.com/' },
  twitter: { icon: <FaTwitter />, link: 'https://twitter.com/crypticmetadev' },
};

 const index  = ({
  bgColor = 'rgb(26, 27, 32)',
  accentColor = '#FFFFFF',
}: {
  bgColor?: string;
  accentColor?: string;
}) => {
  return (
    <div className=" flex justify-center py-16 w-full bg-whit">
      <div className='GTWalsheimProRegular text-white md:text-xl rounded-xl bg-brand_smooth_gray p-4 md:p-10'>
         All NFT prizes are held by raffle in escrow and can be claimed by the winner or creator
         once the draw is done. Raffle tickets cannot be refunded once bought. Raffle tickets
         will not be refunded if you did not win the raffle.
        </div>
    </div>
  );
};


export default index